import { addMinutes } from 'date-fns';

export const addToCalendar = (startDate: string, description: string, location: string) => {
	// Create the .ics URL
	const url = [
		'BEGIN:VCALENDAR',
		'VERSION:2.0',
		'BEGIN:VEVENT',
		'DTSTART:' + new Date(startDate).toISOString().replaceAll('-', '').replaceAll(':', '').replaceAll('.000Z', 'Z'),
		'DTEND:' +
			addMinutes(new Date(startDate), 60)
				.toISOString()
				.replaceAll('-', '')
				.replaceAll(':', '')
				.replaceAll('.000Z', 'Z'),
		'SUMMARY:' + 'Aspen Dental Appointment',
		'DESCRIPTION:' + description,
		'LOCATION:' + location,
		'BEGIN:VALARM',
		'TRIGGER:-PT15M',
		'REPEAT:1',
		'DURATION:PT15M',
		'ACTION:DISPLAY',
		'DESCRIPTION:Reminder',
		'END:VALARM',
		'END:VEVENT',
		'END:VCALENDAR',
	].join('\n');

	window.open('data:text/calendar;charset=utf8,' + encodeURIComponent(url), '_blank');
};
